<!-- Ported from the Polaris kit: src/components/ui/dropdown-menu/DropdownMenuItem.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { reactiveOmit } from '@vueuse/core';
import { DropdownMenuItem, useForwardProps } from 'reka-ui';
import { cn } from '../../lib/utils';

const props = defineProps({
  disabled: { type: Boolean, required: false },
  textValue: { type: String, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
  inset: { type: Boolean, required: false },
  variant: { type: String, required: false, default: 'default' },
});

const delegatedProps = reactiveOmit(props, 'inset', 'variant', 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <DropdownMenuItem
    data-slot="dropdown-menu-item"
    :data-inset="inset ? '' : undefined"
    :data-variant="variant"
    v-bind="forwardedProps"
    :class="
      cn(
        `relative flex cursor-default items-center gap-2 rounded-polaris-sm px-2 py-1.5 type-polaris-body outline-none select-none focus:bg-polaris-accent focus:text-polaris-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[inset]:pl-8 data-[variant=destructive]:text-polaris-destructive data-[variant=destructive]:focus:bg-polaris-destructive/10 data-[variant=destructive]:focus:text-polaris-destructive dark:data-[variant=destructive]:focus:bg-polaris-destructive/20 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 [&_svg:not([class*='text-'])]:text-polaris-muted-foreground [&[data-variant=destructive]>svg]:!text-polaris-destructive`,
        props.class
      )
    "
  >
    <slot />
  </DropdownMenuItem>
</template>
